<template>
  <div>
    <h5 v-if="orderStepper == 3" style="text-align:center;">
      {{ reviewData.orderNo }}
    </h5>

    <v-toolbar style="margin-top:12px">
      <v-btn v-if="orderStepper != 1" icon @click="backPrevious">
        <!-- class="hidden-xs-only" -->
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title>{{ titles[orderStepper] }}</v-toolbar-title>

 

      <!-- <v-btn v-if="orderStepper == 2" style="margin-left: auto;" icon @click="submitCoachListEdit">
        
        <v-icon>
          mdi-content-save
        </v-icon>
      </v-btn> -->

      <v-btn v-if="orderStepper == 3 && !calculated" style="margin-left: auto;" icon @click="submitEdit">
        <!-- class="hidden-xs-only"  -->
        <v-icon>
          mdi-content-save
        </v-icon>
      </v-btn>

      <v-btn v-if="orderStepper == 5" style="margin-left: auto;" icon @click="submitSalesEdit">
        <!-- class="hidden-xs-only"  -->
        <v-icon>
          mdi-content-save
        </v-icon>
      </v-btn>
    </v-toolbar>

    <div v-if="orderStepper == 1 && deleteDialog != true">
      <swipe-list ref="swipeList" class="card" :disabled="!enabled" :items="content.items" item-key="id"
        :revealed.sync="revealed" :item-disabled="({ disabled }) => disabled" :disable-right-swipe="true"
        @closed="setLastEvent('closed', $event)" @leftRevealed="setLastEvent('leftRevealed', $event)"
        @rightRevealed="setLastEvent('rightRevealed', $event)">
        <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
          <!-- item is the corresponding object from the array -->
          <!-- index is clearly the index -->
          <!-- revealLeft is method which toggles the left side -->
          <!-- revealRight is method which toggles the right side -->
          <!-- close is method which closes an opened side -->
          <div ref="content" class="card-content" @click="itemClick(item)">
            <v-list-item>
              <v-list-item-avatar>
                <!-- class="grey lighten-1 white--text" -->
                <v-img :src="avatarGetLink(item.userRecord.avatar)" shape="circle" />
                <!-- <v-icon

      v-text="`mdi-account`"
    ></v-icon> -->
              </v-list-item-avatar>
              <v-list-item-content>
                <!-- class="font-weight-bolder" -->

                <v-list-item-subtitle style="font-weight: 100" v-text="item.orderNo"></v-list-item-subtitle>
                <v-list-item-title class="font-weight-black" v-text="item.userRecord.fullName"></v-list-item-title>
                <v-list-item-title v-text="item.course.courseName"></v-list-item-title>
                <v-list-item-subtitle v-text="`Total : $${item.totalAmount}`"></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="`Session : ${item.sessionTotal -   item.bookedCourse.length}/${item.sessionTotal}`"></v-list-item-subtitle>
                <v-list-item-subtitle v-text="`Expriy Date : ${formatDate(item.expiryDate)}`"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>

        <!-- <template v-slot:right="{ item }">
      <div class="swipeout-action blue"   @click="edit(item)">

        <v-icon large color="white">mdi-format-list-bulleted-square</v-icon>
      </div>
      <div class="swipeout-action red"   @click="submitDelete(item)">

        <v-icon large color="white">mdi-trash-can</v-icon>

      </div>
    </template> -->
        <template v-slot:empty>
          <div>
            <!-- change mockSwipeList to an empty array to see this slot in action  -->search
            list is empty ( filtered or just empty )
          </div>
        </template>
      </swipe-list>
    </div>
    <div v-else-if="orderStepper == 2">
      <v-card class="mt-5 mb-8">
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Order No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.orderNo }}
                </v-card-text>
              </v-col>

        <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Center</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.center.code }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Membership No </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.userRecord.userNo }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Membership Name </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.userRecord.fullName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Gender </b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.userRecord.gender }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Course</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.course.courseName }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Program</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.sessionTotal -   reviewData.bookedCourse.length }}/{{ reviewData.sessionTotal }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Total Amount</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{ reviewData.totalAmount }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Effective Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{
                    reviewData.effectiveDate ?
                      formatDate(reviewData.effectiveDate) : ''
                  }}
                </v-card-text>
              </v-col>

              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  <b>Expiry Date</b>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                <v-card-text class="pl-2" tile>
                  {{
                    reviewData.expiryDate ?
                      formatDate(reviewData.expiryDate) : ''
                  }}
                </v-card-text>
              </v-col>
            </v-row>
            <!-- :enableSearch="true" -->
            <v-col cols="12">
             <h5  style="color:red !important">Please select related Coach in the following list and click save </h5>
 
              <user-list ref="selectCoachList" :user-list="coachList" :default-selected-list="selectedCoach"
       @click="handleCoachClick" @remove="handleCoachRemove"
                limit="3"
                :enableSearch="true"  
                >
              </user-list>
         
            </v-col>

            <v-col cols="12">
              <v-btn color="primary" block @click="nextButton">
                Check/edit Commission
              </v-btn>
            </v-col>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
    <div v-else-if="orderStepper == 3">

      <v-card-title style="word-break: break-word" v-if ="calculated ">  

<span   v-if ="calculated" class="warning-commission"> 
  <br> 
    This section cant't change since commission has already calculated
</span>
 

</v-card-title>  


      <swipe-list ref="swipecoachList" class="card" :disabled="!enabled" :items="coachCommissionList.items"
        item-key="id" :revealed.sync="revealed" :item-disabled="({ disabled }) => disabled" :disable-right-swipe="true">
        <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
          <div class="text-center">
            <v-dialog v-model="deleteDialog" width="600px">
              <v-card v-if="tempItem != null">
                <v-card-title>
                  <span class="wrap editH1Dialog"><b>Are you sure to delete
                      {{ tempItem.userRecord.fullName }} in Order No: {{ reviewData.orderNo }}</b></span>
                </v-card-title>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="dark" text @click="deleteDialog = false">
                    Back
                  </v-btn>

                  <v-btn :loading="loading" color="dark" text @click="confirmSubmitDelete">
                    Confirm
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>

          <v-row no-gutters>
            <v-col cols="9">
              <v-list-item>
                <v-list-item-avatar>
                  <!-- class="grey lighten-1 white--text" -->
                  <v-img :src="avatarGetLink(item.userRecord.avatar)" shape="circle" />
                  <!-- <v-icon

      v-text="`mdi-account`"
    ></v-icon> -->
                </v-list-item-avatar>
                <v-list-item-content>
                  <!-- class="font-weight-bolder" -->

                  <v-list-item-subtitle style="font-weight: 100" v-text="item.orderNo"></v-list-item-subtitle>
                  <v-list-item-title class="font-weight-black" v-text="item.userRecord.fullName"></v-list-item-title>
                  <v-list-item-title>
                    <v-slider v-model="coachCommissionList.items[index].commissionPercentage" step="1" ticks>
                    </v-slider>
                    {{ coachCommissionList.items[index].commissionPercentage }}%
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="3">
              <!-- color="#4fdea4" -->
              <!--  v-if ="!calculated"-->
              <v-btn 
              
              :disabled="calculated"
              tile style="height: 100%; " color="#ff0000" @click="submitDelete(item)">
                <v-icon large color="white">
                  mdi-trash-can
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <!-- <template v-slot:right="{ item }">

      <div class="swipeout-action red"   @click="submitDelete(item)">

        <v-icon large color="white">mdi-trash-can</v-icon>

      </div>
    </template>   -->
        <template v-slot:empty>
          <div>
            <!-- change mockSwipeList to an empty array to see this slot in action  -->
            list is empty ( filtered or just empty )
          </div>
        </template>
      </swipe-list>

      <v-snackbar v-model="snackbar" centered timeout="2000">
        Total percentage must be equal 100%
      </v-snackbar>
    </div>
    <div v-else-if="orderStepper == 4 && deleteDialog != true">
      <v-card-title>
        <span class="warning-commission">
          <br>
          This section cant't change since commission has already calculated
        </span>
      </v-card-title>
      <swipe-list :items="content.items">
        <template v-slot="{ item, index, revealLeft, revealRight, close, revealed, disabled }">
      
          <div ref="content" class="card-content">
            <v-list-item>
              <v-list-item-avatar>
           
                <v-img :src="avatarGetLink(item.userRecord.avatar)" shape="circle" />
            
              </v-list-item-avatar>
              <v-list-item-content>
             

                <v-list-item-subtitle style="font-weight: 100" v-text="item.orderNo"></v-list-item-subtitle>
                <v-list-item-title class="font-weight-black" v-text="item.userRecord.fullName"></v-list-item-title>
                <v-list-item-title v-text="item.course.courseName"></v-list-item-title>
                <v-list-item-subtitle v-text="`Total : $${item.totalAmount}`"></v-list-item-subtitle>
                <v-list-item-subtitle
                  v-text="`Session : ${ item.sessionTotal -   item.bookedCourse.length }/${item.sessionTotal}`"></v-list-item-subtitle>
                <v-list-item-subtitle v-text="`Expriy Date : ${formatDate(item.expiryDate)}`"></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </swipe-list>
    </div>
    <div v-else-if="orderStepper == 5">
      <v-row style="padding-top: 12px;">
        <v-col cols="12">
          <div class="pl-2">
            <span class="text-h9 wrap"><b>Select one or more sales and then click save icon</b><br></span>
          </div>
        </v-col>

        <v-col cols="12">
   
          <user-list ref="selectTempSalesList" :user-list="tempSalesList"  
          :default-selected-list="selectedSales"
          limit="3"
          @click="handleSalesClick"
          :enableSearch="true"  
            @remove="handleSalesRemove"
          
            ></user-list>
       

          
        </v-col>
      </v-row>
    </div>

    <div class="text-center">
      <v-dialog v-model="editDialog" persistent max-width="290">
        <v-card>
          <v-card-title>
            <span class="text-h5 wrap"><b>Transfer order from {{ oldCenter }} to {{ newCenter }}?</b><br></span>

            <span class="wrap editH1Dialog">
              <br>
              All existing incomplete course booking would be cancel if invalid for {{ newCenter }}
            </span>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="dark" text @click="editDialog = false">
              Back
            </v-btn>
            <!-- color="green darken-1" -->
            <v-btn :loading="loading" color="blue" text @click="confirmSubmitEdit">
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <v-btn v-if="orderStepper == 3" color="#4fdea4" absolute bottom right fab @click="findOrderSales">
      <v-icon color="white">
        mdi-plus
      </v-icon>
    </v-btn>

    <v-overlay :z-index="999" :value="progressLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import {
  mdiAccountOutline,
  mdiDeleteOutline,
  mdiDotsVertical,
  mdiExportVariant,
  mdiFileDocumentOutline,
  mdiPlus,
  mdiSquareEditOutline,
} from '@mdi/js'
import { ref } from 'vue'
import * as moment from 'moment'
import { createItem, deleteItem, fetchOutstandingOrderList as fetchList, getItem, updateItem, commissionFetchList } from '@/api/salesOrder'

import {
  createItem as orderSalesmanCreateItem, deleteItem as commissionDeleteItem,
  updateItem as commissionUpdateItem, fetchList as orderSalesmanFetchList
} from '@/api/orderSalesman'

import { fetchList as orderCoachFetchList, updateItem as orderCoachUpdateItem } from '@/api/orderCoach'

import { fetchList as centerFetchList } from '@/api/center'

// import css from '../../src/styles/vue-swipe-actions.css';

import CRUDTable from '@/components/CRUD/CRUDTable'
import { useStore } from '@/store'

import UniversalInput from '@/components/CRUD/UniversalInput.vue'

import SwipeList from '@/components/SwipeList/SwipeList.vue'

// import SwipeList from '@/components/SwipeList/SwipeList.vue'
import UserList from '@/components/UserSelector/UserList'




export default {
  name: 'OrderStandingOrder',
  components: {
    CRUDTable,
    SwipeList,
    UniversalInput,
    UserList,
  },
  data() {
    return {
      enabled: true,
      page: 0,
      revealed: {},
      lastEventDescription: '',
      titles: {
        1: 'Outstanding Order',
        2: '1. Assign Coach',
        3: '2. Assign Commission',
        4: 'Assign Commission',
        5: 'Assign Salesman',
      },
      orderStepper: 1,
      fromDate: null,
      fromMenu: false,
      toDate: null,
      toMenu: false,
      searchKeyWord: '',
      progress: false,
      content: [],
      reviewData: [],
      testitems: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' },
      ],
      centerItems: [],
      tempCenterCode: '',
      inputCenterConfig:
      {
        propName: 'tempCenterCode',

        // label: 'Code',
        // defaultValue: 5,
        type: {
          name: 'select',
          items: [],
          itemText: 'code',
          itemValue: 'id',
        },
      },
      deleteDialog: false,
      voidReason: '',
      editDialog: false,
      oldCenter: '',
      newCenter: '',
      coachList: [],
      coachCommissionList: [],
      percentage: 22,
      percentagebool: false,

      tempItem: null,
      snackbar: false,

      coachRecords: [],
      latestCoachRecords: [],

      tempSalesList: [],
      tempCoachList: [],

      selectedSales: [],
      selectedCoach: [],
      tempSelectedSales: [],
      tempSelectedCoach : [],

      calculated: false,

 
    }
  },

  mounted() {
    this.submitSearch()

    // this.$store.dispatch('users/listCoach')
    //   .then(result => {
    //     console.log('listCoach result', result)
    //     this.coachList.push(...result)
    //   })
    //   .catch(err => {
    //     console.log('err', err)
    //   })

    // ideally should be in some global handler/store
    window.addEventListener('keydown', this.onKeyDown)
    window.addEventListener('keyup', this.onKeyUp)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyUp)
  },

  // mounted(){
  //   // this.$set(this.inputCenteConfig.type, 'items', this.centerItems)

  // },
  methods: {

    scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
},

    avatarGetLink(avatar){
if (avatar == undefined){
  return ''
}

return process.env.VUE_APP_BASE_API +  avatar
},

    // #region orderstepper1
    itemClick(e) {
      console.log(e, 'item click')
      this.orderStepper = 2
      this.scrollToTop()
      this.reviewData = e

      this.fetehCoachData()
    },



    fetehCoachData() {

      this.progressLoading = true
      orderCoachFetchList({ SalesOrderID: this.reviewData.id }).then(response => {
        this.progressLoading = false
        const tempReponse = response.data.items
        this.tempCoachList = []
        this.coachList = []
        this.selectedCoach = []
        this.tempSelectedCoach = []
        
        this.tempCoachList = tempReponse
        //  this.coachList = [...tempReponse.filter(object => object.assignCoach === false)];
        this.coachList = [...tempReponse.filter(object => object.assignCoach === false)]

        console.log(' this.coachList = this.coachList.userRecord', this.coachList)
        this.selectedCoach = [...tempReponse.filter(object => object.assignCoach === true)]
        this.tempSelectedCoach =    this.selectedCoach
        // this.tempCoachList = [...this.selectedCoach]
        // console.log(' this.tempCoachList = this.selectedCoach.userRecord', this.selectedCoach)
      })
        .catch(err => {
          this.progressLoading = false
        })
    },

    // #endregion

    // #region orderstepper2
    nextButton() {
      console.log('nextButton')
      this.orderStepper = 3
      this.scrollToTop()
      this.progressLoading = true

      this.fetchCoachdata()

      this.getCalculated()

      // this.fetchSalesData()
    },

    //save icon 
    submitCoachListEdit() {
      this.progressLoading = true
      orderCoachUpdateItem({ SalesOrderID: this.reviewData.id, UserRecord:   this.tempSelectedCoach  })
        .then(response => {
          this.progressLoading = false
          this.fetehCoachData()
        })
        .catch(err => {
          this.progressLoading = false
          
        })
 
    },




    fetchCoachList() {
      this.progressLoading = true

      // salesorderid
      orderCoachFetchList(this.latestCoachRecords)
        .then(response => {
          this.progressLoading = false
        })
        .catch(err => {
          this.progressLoading = false
        })
    },

 
    handleCoachClick(item) {
      // console.log('handleCoachClick',item)
      // this.selectedCoach.push(item)
      
      this.tempSelectedCoach.push(item)
      console.log('handleCoachClick',  this.tempSelectedCoach)

    },
    handleCoachRemove(item) {

      const index = this.tempSelectedCoach.indexOf(item); // get the index of 'banana'
      if (index !== -1) {
        this.tempSelectedCoach.splice(index, 1); // remove the item at the found index
      }
      console.log('handleCoachRemove',  this.tempSelectedCoach)
 

    },

    // #endregion

    // #region orderstepper3
    findOrderSales() {
      console.log('findOrderSales')
      this.orderStepper = 5
      this.scrollToTop()
      this.tempSelectedSales = []
      this.fetchSalesData()

      // this.progressLoading = true
    },

    fetchSalesData() {
      this.progressLoading = true
      this.tempSelectedSales = []
      orderSalesmanFetchList({ page: 0, limit: 0, SalesOrderID: this.reviewData.id })
        .then(response => {
          this.progressLoading = false
          this.tempSalesList = response.data.items
        })
        .catch(err => {
          this.progressLoading = false
        })
    },

   
    handleSalesClick(item) {
      
       
      this.tempSelectedSales.push(item)
 
    
      console.log('this.tempSelectedSales' , this.tempSelectedSales)

    },

    handleSalesRemove(item) {

const index = this.tempSelectedSales.indexOf(item); // get the index of 'banana'
if (index !== -1) {
  this.tempSelectedSales.splice(index, 1); // remove the item at the found index
}
console.log('this.tempSelectedSales' , this.tempSelectedSales)
 

},

salesSearchCallback(record,searchValue){
  console.log('salesSearchCallback', searchValue)
  if(searchValue.length > 0){
    this.tempSalesList = this.tempSalesList.filter(item => {
      return item.salesName.toLowerCase().indexOf(searchValue.toLowerCase())!== -1
    })
  }else{
    this.tempSalesList = this.tempSalesList.filter(item => {
      return true
    })
  }
},
 
 


    submitSalesEdit() {
      console.log('submitSalesEdit', this.tempSelectedSales)
      this.progressLoading = true
      orderSalesmanCreateItem({ SalesOrderID: this.reviewData.id, UserRecord:  this.tempSelectedSales   })
        .then(response => {
          this.fetchSalesData()
          this.fetchCoachdata()
          this.progressLoading = false 
          this.orderStepper = 3
          this.scrollToTop()
          this.selectedSales = []
          this.tempSelectedSales = []
        })
        .catch(err => {
          this.selectedSales = []
          this.tempSelectedSales = []
          this.progressLoading = false
          this.orderStepper = 3
          this.scrollToTop()
        })
    },

    // #endregion

    // #region pagecontrol
    submitCommissionPage() {
      this.orderStepper = 4
      this.scrollToTop()
      console.log('submitCommissionPage')
    },

    backPrevious() {
     if (this.orderStepper == 3){
      this.fetehCoachData() 
      this.getCalculated()
     }
    
    
      
      if (this.orderStepper == 5) {
        this.orderStepper = 4
        
      }

      if (this.orderStepper > 1) {
        this.orderStepper -= 1
      }
      if (this.orderStepper == 1) {
        this.content = []
        this.submitSearch()
      }
      

      
      

    },

    // endregoin

    // #region fetchdata
    fetchCoachdata() {
      this.progressLoading = true
      return new Promise((resolve, reject) => {
      // this.coachCommissionList = []
      commissionFetchList({ page: 0, limit: 0, orderNo: this.reviewData.orderNo })
        .then(response => {
          this.progressLoading = false
          console.log('commissionFetchList', response)
          this.coachCommissionList = response.data

          resolve("Operation succeeded");
        })
        .catch(err => {
          this.progressLoading = false
          reject("Operation succeeded");
          // loading = false
        })

 
  

});
    },

    centerFetchList() {
      centerFetchList({ page: 0, limit: 0 })
        .then(response => {
          console.log('center  response', response)
          this.centerItems = response.data.items
          this.inputCenterConfig.type.items.push(...this.centerItems)
          this.tempCenterCode = this.reviewData.centerID
        })
        .catch(err => {
          // loading = false
        })
    },

    // #endregion

    // #region edit

    // #endregion

    edit(item) {
      console.log('edit', item)
      this.reviewData = item
      this.orderStepper = 3
      this.scrollToTop()
      this.centerFetchList()
    },

    // #region submit

    sumbitCenterCode(item) {
      console.log('sumbitCenterCode', item)
    },

    submitEdit() {
      let percentageValue = 0
      console.log('aaa', this.coachCommissionList.items.length)
      for (let i = 0; i < this.coachCommissionList.items.length; i++) {
        console.log('this.coachCommissionList[i].CommissionPercentage', this.coachCommissionList.items[i].commissionPercentage)
        percentageValue += this.coachCommissionList.items[i].commissionPercentage
      }

      console.log('percentageValue', percentageValue)

      if (percentageValue == 100) {
        // this.progressLoading = true
        console.log('this.coachCommissionList', this.coachCommissionList)

        // this.progressLoading = true
        commissionUpdateItem(this.coachCommissionList).then(response => {
          this.submitCoachListEdit() 

          this.fetchCoachdata().then(response => {   this.submitSearch() }).catch(error => {})
          // this.getCalculated()
          
         
         
 
        })
          .catch(err => {

          })
      } else {
        this.snackbar = true
      }



    },

    getCalculated(){
      getItem(this.reviewData.id).then(response => {

        this.calculated = response.data.record.calculated
        }).catch(err => {
        })
    },

    // #endregion

    confirmSubmitEdit() {
      this.loading = true
      updateItem(this.reviewData)
        .then(response => {
          this.editDialog = false
          this.loading = false
          this.submitSearch()
        })
        .catch(err => {
          this.loading = false
          this.editDialog = false
        })
    },

    submitDelete(item) {
      console.log('submitDelete', item)
      this.tempItem = item
      this.deleteDialog = true
    },

    submitCommissionDelete(item) {
      console.log('submitCommissionDelete', item)
      this.deleteDialog = true
    },

    confirmSubmitDelete() {
      this.loading = true

      commissionDeleteItem(this.tempItem)
        .then(response => {
          this.deleteDialog = false
          this.loading = false

          this.fetchCoachdata()
        })
        .catch(err => {
          this.deleteDialog = false
          this.loading = false
        })
    },

    setLastEvent(name, { item, index }) {
      this.lastEventDescription = {
        name,
        index,
        id: item.id,
      }
    },

  

    // keyboard
    onKeyDown(e) {
      if (e.keyCode !== 16) return
      this.enabled = false
    },
    onKeyUp(e) {
      if (e.keyCode !== 16) return
      this.enabled = true
    },

    formatDate(date) {
      const d = new Date(date)
      let month = `${d.getMonth() + 1}`
      let day = `${d.getDate()}`
      const year = d.getFullYear()

      if (month.length < 2) { month = `0${month}` }
      if (day.length < 2) { day = `0${day}` }

      return [year, month, day].join('-')
    },
    submitSearch() {
    
      this.progressLoading = true

      //  loading.value = true
      fetchList({
        page: 0,
        limit: 0,
        Todate: this.toDate,
        FromDate: this.fromDate,
        searchKeyWord: this.searchKeyWord,
        calculated: false,
      })
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)
         
          this.scrollToTop()
          // loading = false
        })
        .catch(err => {
          this.progressLoading = false
          this.orderStepper = 1

          // loading = false
        })
    },
    submitSearchWithoutChangeOrderStepper() {
      this.progressLoading = true

      //  loading.value = true
      fetchList({ page: 0, limit: 0, Todate: this.toDate, FromDate: this.fromDate, searchKeyWord: this.searchKeyWord })
        .then(response => {
          this.progressLoading = false
          console.log('Order History response', response)
          this.content = response.data
          console.log('content value', this.content)

          // loading = false
        })
        .catch(err => {
          this.progressLoading = true

          // loading = false
        })
    },

  },
  setup() {
    const loading = ref(false)
    const progressLoading = ref(false)
 

    return {
 
      loading,
      progressLoading,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>

<style>
/* @import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"); */

.swipeout-padding {
  margin-left: -2%;
}

.centered {
  position: fixed;
  /* or absolute */
  top: 50%;
  left: 50%;
}

.centered-button {
  margin-top: 12px;
  margin-left: 50%;

}

.editH1Dialog {
  color: red !important;
  font-size: 18px;
  width: 100%;
  /*Dont really required*/

  text-align: center;
  word-wrap: break-word;
}

.warning-commission {
  color: red !important;
  font-size: 12px;
  text-align: left;
  word-wrap: break-word;
}

.wrap {
  width: 100%;
  /*Dont really required*/
  text-align: center;
  word-wrap: break-word;
}

/* app specific styles */
.vcenter {
  display: flex;
  align-items: center;
  height: 56px;
}

.swipeout-action {
  display: flex;
  align-items: center;
  padding: 0 3rem;
  cursor: pointer;
  left: 0;

}

/* https://developer.apple.com/design/human-interface-guidelines/ios/visual-design/color/ */
.swipeout-action.blue {
  color: white;
  background-color: rgb(0, 122, 255);
}

.swipeout-action.blue:hover {
  background-color: darken(rgb(0, 122, 255), 5%);
}

.swipeout-action.purple {
  color: white;
  background-color: rgb(88, 86, 214);
}

.swipeout-action.purple:hover {
  background-color: darken(rgb(88, 86, 214), 5%);
}

.swipeout-action.red {
  color: white;
  background-color: rgb(255, 59, 48);
}

.swipeout-action.red:hover {
  background-color: darken(rgb(255, 59, 48), 5%);
}

.swipeout-action.green {
  color: white;
  background-color: rgb(76, 217, 100);
}

.swipeout-action.green:hover {
  background-color: darken(rgb(76, 217, 100), 5%);
}

.swipeout-list-item {
  flex: 1;
  border-bottom: 1px solid lightgray;
}

.swipeout-list-item:last-of-type {
  border-bottom: none;
}

.card {
  width: 100%;
  background-color: white;
  border-radius: 3px;
  box-shadow: none;
  border: 1px solid lightgray;
}

.card-content {
  padding: 1rem;
}

.transition-right {
  transform: translate3d(100%, 0, 0) !important;
}

.transition-left {
  transform: translate3d(-100%, 0, 0) !important;
  /* transform: translate3d(-100%, 0 ,0) !important; */
}

.toolbar {
  display: flex;
  align-items: center;
}

.toolbar .toolbar-section {
  flex: 0 0 auto;
}

.toolbar .toolbar-section--center {
  flex: 1000 1 0%;
}
</style>
